// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2FCSA","inputWrap":"Table_inputWrap__HAemS","col":"Table_col__7wIpe","bmiTooltip":"Table_bmiTooltip__uiKyz"};